export default __webpack_public_path__ + "static/media/003-hoodie.a04ebcaf.svg";